
@switch (columnId) {
  @case (DfmFileOrderByEnum.Id) {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case (DfmFileOrderByEnum.FullName) {
    <lib-text-table-column>
      {{ element.fullName }}
    </lib-text-table-column>
  }
  @case (DfmFileOrderByEnum.Owner) {
    <lib-text-table-column>
      {{ element.owner }}
    </lib-text-table-column>
  }
  @case (DfmFileOrderByEnum.CreatedUtc) {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @case (DfmFileOrderByEnum.UpdatedUtc) {
    <lib-date-time-label [dateUtc]="element.updatedUtc"></lib-date-time-label>
  }
  @case (DfmFileOrderByEnum.Status) {
    <lib-status-chip
      class="dfm-file-statuses"
      [status]="element.status">
    </lib-status-chip>
  }
  @case ('reprocess') {
    <lib-vitu-tooltip text="Reprocess">
      <i class="far fa-redo global-table-cell-image-link" (click)="onClickReprocess()"></i>
    </lib-vitu-tooltip>
  }
  @case ('download') {
    <lib-vitu-tooltip text="Download">
      <i class="far fa-file-download global-table-cell-image-link" (click)="onClickDownload()"></i>
    </lib-vitu-tooltip>
  }
  @default {
  }
}
